var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonChart',{attrs:{"data":_vm.data,"config":_vm.chartConfig,"customers":_vm.customers,"selectedPeriod":_vm.selectedPeriod,"customerDataField":'usage',"containerClass":"chart-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }